<template>
  <div class="invoice-create-top-grid">
    <article class="invoice-create-card invoice-create-card--accent-billing simple-note-customer-card">
      <header class="invoice-create-card__head invoice-create-card__head--space">
        <h3>
          <i class="fa fa-user-o invoice-create-section-icon invoice-create-section-icon--billing" aria-hidden="true"></i>
          {{ text.create.ui.customerCard.title }}
        </h3>
      </header>

      <multiselect
        v-model="selectedCustomerModel"
        :options="customerOptions"
        track-by="value"
        label="label"
        :show-labels="false"
        :searchable="true"
        :allow-empty="true"
        class="invoice-create-receiver-select app-modal-select"
        :placeholder="text.create.ui.customerCard.selectorPlaceholder"
      >
        <template #noResult><span>{{ text.create.ui.customerCard.noOptions }}</span></template>
        <template #noOptions><span>{{ text.create.ui.customerCard.noOptions }}</span></template>
      </multiselect>

    </article>

    <SimpleNoteCreateInfoCard
      :note-info="noteInfo"
      :payment-form-options="paymentFormOptions"
      @note-info-change="$emit('note-info-change', $event)"
    />
  </div>
</template>

<script>
import SimpleNoteCreateInfoCard from '@/components/simple-notes/create/SimpleNoteCreateInfoCard.vue';
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('simpleNotes');

export default {
  name: 'SimpleNoteCreateTopSection',
  components: {
    SimpleNoteCreateInfoCard,
  },
  props: {
    customerOptions: {
      type: Array,
      default: () => [],
    },
    selectedReceiver: {
      type: Object,
      default: null,
    },
    paymentFormOptions: {
      type: Array,
      default: () => [],
    },
    noteInfo: {
      type: Object,
      required: true,
    },
  },
  emits: ['select-receiver', 'note-info-change'],
  data() {
    return {
      text,
    };
  },
  computed: {
    selectedCustomerModel: {
      get() {
        return this.selectedReceiver;
      },
      set(value) {
        this.$emit('select-receiver', value || null);
      },
    },
  },
  methods: {},
};
</script>

<style scoped>
.simple-note-customer-card {
  position: relative;
}
</style>
